import {
  AREA_TIERS,
  loadNotifySettings,
  saveNotifySettings,
  type AreaNotifySettings,
  type AreaTier,
} from '../minimapPrefs.js';
import type { SettingsSection } from '../SettingsModal.js';

const TIER_LABELS: Record<AreaTier, string> = {
  neighbourhood: 'Neighbourhood',
  suburb: 'Suburb / District',
  city: 'City / Town',
  county: 'County',
  state: 'State / Region',
  country: 'Country',
};

/** Map section: tier toggles for area-entry notifications. The exported function
 *  also returns `get()` so main.ts's per-frame area-detection tick can read the
 *  latest settings without going through SettingsModal. */
export function createMapSection(onChange: (s: AreaNotifySettings) => void): SettingsSection & {
  get(): AreaNotifySettings;
} {
  let settings = loadNotifySettings();
  return {
    id: 'map',
    title: 'Map',
    get(): AreaNotifySettings {
      return settings;
    },
    build(parent: HTMLElement): void {
      parent.replaceChildren();

      const sectionTitle = document.createElement('div');
      sectionTitle.className = 'settings-section-title';
      sectionTitle.textContent = 'Area notifications';
      parent.appendChild(sectionTitle);

      const help = document.createElement('div');
      help.className = 'settings-section-help';
      help.textContent =
        'Show a fade-in label when entering a new area. Country / state currently fire only at session start.';
      parent.appendChild(help);

      for (const tier of AREA_TIERS) {
        const label = document.createElement('label');
        label.className = 'settings-toggle';
        const cb = document.createElement('input');
        cb.type = 'checkbox';
        cb.checked = settings[tier];
        cb.addEventListener('change', () => {
          settings = { ...settings, [tier]: cb.checked };
          saveNotifySettings(settings);
          onChange(settings);
        });
        label.appendChild(cb);
        const text = document.createElement('span');
        text.textContent = TIER_LABELS[tier];
        label.appendChild(text);
        parent.appendChild(label);
      }
    },
  };
}
